/* eslint-disable complexity */
import React from 'react';

import Button from '@atlaskit/button';

import { DetailsRow } from '@qality/common-components/src/atoms/DetailsRow';
import { Text } from '@qality/common-components/src/atoms/Text';

type Props = { executionsCount: number; executionsHistoryUrl: string };

export const TextExecutionDetailsHistory = ({
  executionsCount,
  executionsHistoryUrl,
}: Props): JSX.Element => {
  return (
    <DetailsRow>
      <DetailsRow.Label>Execution history:</DetailsRow.Label>
      <DetailsRow.Value>
        {!executionsCount ? (
          <Text inactive>None</Text>
        ) : (
          <Button appearance='link' href={executionsHistoryUrl} target='_BLANK'>
            {executionsCount}&nbsp;
            {executionsCount > 1 ? 'executions' : 'execution'}
          </Button>
        )}
      </DetailsRow.Value>
    </DetailsRow>
  );
};
